module.exports = __webpack_public_path__ + "img/gd-sharepoint-papers.95339b68.png";